import { cancelOrder, takeOrder, delOrder, payOrder } from "@api/order";
import dialog from "@utils/dialog";
import { pay } from "@libs/wechat";
import router from "../router";

export function cancelOrderHandle(orderId) {
  return new Promise((resolve, reject) => {
    dialog.confirm({
      mes: "确认取消该订单?",
      opts() {
        cancelOrder(orderId)
          .then((res) => {
            dialog.success("取消成功");
            resolve(res);
          })
          .catch((err) => {
            dialog.error("取消失败");
            reject(err);
          });
      },
    });
  });
}

export function takeOrderHandle(orderId) {
  return new Promise((resolve, reject) => {
    takeOrder(orderId)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        dialog.error("收货失败");
        reject(err);
      });
  });
}

export function delOrderHandle(orderId) {
  return new Promise((resolve, reject) => {
    dialog.confirm({
      mes: "确认删除该订单?",
      opts() {
        delOrder(orderId)
          .then((res) => {
            dialog.success("删除成功");
            resolve(res);
          })
          .catch((err) => {
            dialog.error("删除失败");
            reject(err);
          });
      },
    });
  });
}

export function payOrderHandle(orderId, type, from) {
  return new Promise((resolve, reject) => {
    dialog.loading.open("");
    let data = {};
    payOrder(orderId, type, from)
      .then((res) => {
        data = res.data;
        setTimeout(() => {
          dialog.loading.close();
        }, 1000);
        switch (data.status) {
          case "WECHAT_H5_PAY":
            reject(data);
            setTimeout(() => {
              location.replace(data.result.jsConfig.mweb_url);
            }, 100);
            break;
          case "ORDER_EXIST":
          case "EXTEND_ORDER":
          case "PAY_ERROR":
          case "PAY_DEFICIENCY":
            dialog.toast({ mes: res.msg });
            reject(data);
            break;
          case "SUCCESS":
            //status: 1-跳转到 /order/status/:id
            //        2-跳转到外部url
            //        3-提示msg内容
            //       -1-提示msg内容，刷新页面

            // dialog.success(res.msg);
            // resolve(data);
            if (data.result.status == 1) {
              that.$router.push({ path: "/order/status/" + data.result.order_id });
            } else if (data.result.status == 2) {
              // setTimeout(() => {
              //   location.replace(data.result.url);
              // }, 1000);
              // setTimeout(() => {
              //   history.replaceState(null, null, data.result.url);
              //   window.location.reload();
              // }, 3000);

              setTimeout(() => {
                try {
                  window.location.replace(data.result.url);
                } catch (error) {
                  window.location = data.result.url;
                }
              }, 1000);
            } else if (data.result.status == 3) {
              dialog.success(res.msg);
            } else if (data.result.status == -1) {
              dialog.toast(res.msg);
            } else {
              dialog.toast("系统开小差了！！！");
            }
            resolve(data);
            break;
          case "WECHAT_PAY":
            pay(data.result.jsConfig).then(() => {
              resolve(data);
            });
        }
      })
      .catch((err) => {
        dialog.loading.close();
        dialog.toast({ mes: err.msg || "订单支付失败" });
        resolve(data);
      });
  });
}

export function goShopDetail(item) {
  return new Promise((resolve) => {
    if (item.activity && item.activity.type === "1") {
      router.push({
        path: "/activity/seckill_detail/" + item.activity.id + "/" + item.activity.time + "/1",
      });
    } else if (item.activity && item.activity.type === "2") {
      router.push({
        path: "/activity/dargain_detail/" + item.activity.id,
      });
    } else if (item.activity && item.activity.type === "3") {
      router.push({
        path: "/activity/group_detail/" + item.activity.id,
      });
    } else {
      resolve(item);
    }
  });
}
